/**
 * Icon Components
 * Using react-icons library (NO emojis)
 * Provides consistent icon components throughout the app
 */

import {
  MdShoppingCart,
  MdSearch,
  MdClose,
  MdCheck,
  MdAccessTime,
  MdWarning,
  MdInfo,
  MdLocationOn,
  MdRestaurant,
  MdAttachMoney,
  MdArrowBack,
  MdArrowForward,
  MdExpandMore,
  MdChevronRight,
  MdChevronLeft,
  MdDelete,
  MdAdd,
  MdRemove,
  MdFavorite,
  MdShare,
  MdMenu,
  MdLanguage,
  MdSettings,
  MdAccessibility,
  MdTextFields,
  MdVisibility,
  MdAnimation,
  MdKeyboard,
  MdRocket,
  MdArrowUpward,
  MdRefresh,
  MdStar,
  MdCheckCircle,
  MdPhone,
  MdEmail,
  MdLanguage as MdWebsite,
  MdEco,
  MdGrain,
  MdLocalFireDepartment,
  MdFitnessCenter,
  MdLightMode,
  MdBlock,
  MdWaterDrop,
  MdGroup,
} from 'react-icons/md';

import {
  IoCheckmarkCircle,
  IoCloseCircle,
  IoWarning,
  IoInformationCircle,
} from 'react-icons/io5';

// Export Material Design icons as primary
export const CartIcon = ({ size = 24, className = "" }) => (
  <MdShoppingCart size={size} className={className} />
);

export const SearchIcon = ({ size = 24, className = "" }) => (
  <MdSearch size={size} className={className} />
);

export const CloseIcon = ({ size = 24, className = "" }) => (
  <MdClose size={size} className={className} />
);

export const CheckIcon = ({ size = 24, className = "" }) => (
  <MdCheck size={size} className={className} />
);

export const TimeIcon = ({ size = 24, className = "" }) => (
  <MdAccessTime size={size} className={className} />
);

export const WarningIcon = ({ size = 24, className = "" }) => (
  <MdWarning size={size} className={className} />
);

export const InfoIcon = ({ size = 24, className = "" }) => (
  <MdInfo size={size} className={className} />
);

export const LocationIcon = ({ size = 24, className = "" }) => (
  <MdLocationOn size={size} className={className} />
);

export const RestaurantIcon = ({ size = 24, className = "" }) => (
  <MdRestaurant size={size} className={className} />
);

export const CashIcon = ({ size = 24, className = "" }) => (
  <MdAttachMoney size={size} className={className} />
);

export const BackIcon = ({ size = 24, className = "" }) => (
  <MdArrowBack size={size} className={className} />
);

export const ArrowForwardIcon = ({ size = 24, className = "" }) => (
  <MdArrowForward size={size} className={className} />
);

export const ChevronDownIcon = ({ size = 24, className = "" }) => (
  <MdExpandMore size={size} className={className} />
);

export const ChevronRightIcon = ({ size = 24, className = "" }) => (
  <MdChevronRight size={size} className={className} />
);

export const ChevronLeftIcon = ({ size = 24, className = "" }) => (
  <MdChevronLeft size={size} className={className} />
);

export const TrashIcon = ({ size = 24, className = "" }) => (
  <MdDelete size={size} className={className} />
);

export const AddIcon = ({ size = 24, className = "" }) => (
  <MdAdd size={size} className={className} />
);

export const RemoveIcon = ({ size = 24, className = "" }) => (
  <MdRemove size={size} className={className} />
);

export const HeartIcon = ({ size = 24, className = "" }) => (
  <MdFavorite size={size} className={className} />
);

export const ShareIcon = ({ size = 24, className = "" }) => (
  <MdShare size={size} className={className} />
);

export const MenuIcon = ({ size = 24, className = "" }) => (
  <MdMenu size={size} className={className} />
);

export const LanguageIcon = ({ size = 24, className = "" }) => (
  <MdLanguage size={size} className={className} />
);

export const SettingsIcon = ({ size = 24, className = "" }) => (
  <MdSettings size={size} className={className} />
);

export const AccessibilityIcon = ({ size = 24, className = "" }) => (
  <MdAccessibility size={size} className={className} />
);

// Ionicons alternatives (exported for variety)
export const CheckmarkCircleIcon = ({ size = 24, className = "" }) => (
  <IoCheckmarkCircle size={size} className={className} />
);

export const CloseCircleIcon = ({ size = 24, className = "" }) => (
  <IoCloseCircle size={size} className={className} />
);

export const WarningCircleIcon = ({ size = 24, className = "" }) => (
  <IoWarning size={size} className={className} />
);

export const InfoCircleIcon = ({ size = 24, className = "" }) => (
  <IoInformationCircle size={size} className={className} />
);

// Additional icons for accessibility panel
export const TextFieldsIcon = ({ size = 24, className = "" }) => (
  <MdTextFields size={size} className={className} />
);

export const EyeIcon = ({ size = 24, className = "" }) => (
  <MdVisibility size={size} className={className} />
);

export const AnimationIcon = ({ size = 24, className = "" }) => (
  <MdAnimation size={size} className={className} />
);

export const KeyboardIcon = ({ size = 24, className = "" }) => (
  <MdKeyboard size={size} className={className} />
);

export const RocketIcon = ({ size = 24, className = "" }) => (
  <MdRocket size={size} className={className} />
);

export const ArrowUpIcon = ({ size = 24, className = "" }) => (
  <MdArrowUpward size={size} className={className} />
);

export const RefreshIcon = ({ size = 24, className = "" }) => (
  <MdRefresh size={size} className={className} />
);

export const StarIcon = ({ size = 24, className = "" }) => (
  <MdStar size={size} className={className} />
);

export const CheckCircleIcon = ({ size = 24, className = "" }) => (
  <MdCheckCircle size={size} className={className} />
);

export const PhoneIcon = ({ size = 24, className = "" }) => (
  <MdPhone size={size} className={className} />
);

export const EmailIcon = ({ size = 24, className = "" }) => (
  <MdEmail size={size} className={className} />
);

export const WebsiteIcon = ({ size = 24, className = "" }) => (
  <MdWebsite size={size} className={className} />
);

// Dietary Tag Icons
export const VeganIcon = ({ size = 24, className = "" }) => (
  <MdEco size={size} className={className} />
);

export const GrainIcon = ({ size = 24, className = "" }) => (
  <MdGrain size={size} className={className} />
);

export const FlameIcon = ({ size = 24, className = "" }) => (
  <MdLocalFireDepartment size={size} className={className} />
);

export const FitnessIcon = ({ size = 24, className = "" }) => (
  <MdFitnessCenter size={size} className={className} />
);

export const LightIcon = ({ size = 24, className = "" }) => (
  <MdLightMode size={size} className={className} />
);

export const BlockIcon = ({ size = 24, className = "" }) => (
  <MdBlock size={size} className={className} />
);

export const DropIcon = ({ size = 24, className = "" }) => (
  <MdWaterDrop size={size} className={className} />
);

export const PeopleIcon = ({ size = 24, className = "" }) => (
  <MdGroup size={size} className={className} />
);
